// src/app/core/mainPage/mainPagecomp/VideoSection/mockData.ts
import type { VideoModelData } from '../comp/types';

export const MOCK_VIDEO_MODELS: VideoModelData[] = [
  {
    id: 'runway-gen3',
    name: 'Runway Gen-3',
    description: 'Создание коротких видео по текстовому описанию',
    videos: [
      'https://media.giphy.com/media/3o7aD2sa1QqC8GmgE8/giphy.gif',
      'https://media.giphy.com/media/l0HlNQ03J5JxX6lva/giphy.gif',
      'https://media.giphy.com/media/26ufdipQqU2lhNA4g/giphy.gif',
      'https://media.giphy.com/media/xT0xeJpnrWC4XWblEk/giphy.gif',
    ],
  },
  {
    id: 'kling-ai',
    name: 'Kling AI',
    description: 'Генерация реалистичных видеороликов',
    videos: [
      'https://media.giphy.com/media/3o7TKsQ8UJfCjH0ZLi/giphy.gif',
      'https://media.giphy.com/media/l0HlGqXQHhGIlJw36/giphy.gif',
      'https://media.giphy.com/media/26gsjCWxRj0jrXpP2/giphy.gif',
      'https://media.giphy.com/media/xT0xeuOy2Fcl9rf8X6/giphy.gif',
    ],
  },
  {
    id: 'pika-labs',
    name: 'Pika Labs',
    description: 'Плавные анимации и переходы',
    videos: [
      'https://media.giphy.com/media/3o7TKsZQvTQxB7n1TW/giphy.gif',
      'https://media.giphy.com/media/l0HlKrB02QY0R6C1O/giphy.gif',
      'https://media.giphy.com/media/26ufgGDiKtONdTNqo/giphy.gif',
      'https://media.giphy.com/media/xT0xeMA62E1LdzZoJ2/giphy.gif',
    ],
  },
];